/**
 * Short label for schedule calendars: registered or allocated headcount vs capacity.
 * Backend: EventScheduled.to_calendar_dict (student_count, effective_capacity, capacity).
 */

export function formatSessionParticipantsLabel(ev) {
  if (!ev || typeof ev !== "object") return "";
  const rawN = ev.student_count;
  if (rawN == null || rawN === "") return "";
  const n = Number(rawN);
  if (!Number.isFinite(n) || n < 0) return "";

  const capEff =
    ev.effective_capacity != null && ev.effective_capacity !== ""
      ? Number(ev.effective_capacity)
      : NaN;
  const capEv = ev.capacity != null && ev.capacity !== "" ? Number(ev.capacity) : NaN;

  if (Number.isFinite(capEff) && capEff > 0) {
    return `${n}/${capEff}`;
  }
  if (Number.isFinite(capEv) && capEv > 0) {
    return `${n}/${capEv}`;
  }
  return `${n}`;
}
